export default __webpack_public_path__ + "static/media/argonaute.95c7f1f0.png";